import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "../tableComponent";
import config from '../../config'

class Component extends TableComponent {

  resetOnMount = true

  makeColumns = () => {
    return [
      {
        Header: "Date",
        accessor: "created",
        minWidth: 60,
        Cell: props => 
          <div>{moment(props.value*1000).format("D MMM YYYY, HH:mm:ss")}</div>,
        Footer: props => <span>{this.props.total.count || 0}</span>
      }, {
        Header: "Email",
        accessor: "email",
        minWidth: 60,
      }, {
        Header: "Name",
        accessor: "name",
        minWidth: 60,
      }, {
        Header: "Card number",
        accessor: "card_number",
        minWidth: 60,
      }, {
        Header: "Message",
        accessor: "message",
        minWidth: 120,
      }, {
        Header: "Mid",
        accessor: "support_site",
        minWidth: 50,
      }, {
        Header: "Cancel",
        accessor: "id",
        id: "cancel",
        minWidth: 60,
        Cell: props => {
          if (props.original.state == 'settle' || props.original.state == 'auth') {
            return (
              <button 
                type="button" 
                class="btn btn-sm btn-block btn-aff-toggle warning"
                onClick={e => {this.handleToggleData("canceled",props,"state",true)}}>Refund                
              </button>            
            )
          } else if (props.original.member_id == '0') {
            return <div>Sale not found</div>
          } else {
            return <div>{props.original.state == 'canceled' ? 'Refunded' : props.original.state}</div>
          }
        }          
      }
    ]
  }

  apiPath = "hookupbay/refunds"
  editApiPath = "hookupbay/update_transaction"

  tableParams = {
    manual: true,
    sorted: [{
      id: "created",
      desc: true
    }],
    showAll: false
  }

  render() {
    return (
      <div>
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"hookupbay_refunds")

